import { unsupportedBrowserHandler } from "./compatibility-detection";
import { handleViewportHeight, disableScroll, enableScroll } from "./helpers";
import { handleExperimentEvent } from "./analyticsListeners";
import { debounce } from "lodash";

window.addEventListener('load', () => {
    unsupportedBrowserHandler();
    handleViewportHeight();
});

window.addEventListener('resize', handleViewportHeight);
window.addEventListener('experiment-event', debounce((event) => handleExperimentEvent(event.detail.exp_variant_string), 1000));

document.addEventListener('disable-scroll', disableScroll);
document.addEventListener('enable-scroll', enableScroll);
